import { SubAPI } from "./SubAPI";
export class Receivables extends SubAPI {
    list(props) { return this.fetcher.get("/api/receivables", props); }
    get(props) { return this.fetcher.get("/api/receivable", props); }
    upsert(input) { return this.fetcher.post("/api/receivable", input); }
    listItems(props) { return this.fetcher.get("/api/receivable/items", props); }
    upsertItem(input) { return this.fetcher.post("/api/receivable/item", input); }
    removeAttachment(input) { return this.fetcher.post("/api/receivable/remove-attachment", input); }
    uploadAttachment(input) { return this.fetcher.postFormData("/api/receivable/upload-attachment", { id: input.id.toString(), file: input.file }); }
    approve(input) { return this.fetcher.post("/api/receivable/approve", input); }
    quickbooksSync(input) { return this.fetcher.post("/api/receivable/quickbooks-sync", input); }
}
